import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { saveRecurrentSubsidy } from "../save-recurrent-subsidy";
import { resetAllowanceMemory } from "../../../infrastructure/allowance-config-repository";
import { translate as t } from "../../../infrastructure/translate/localization";

import "./information-section.scss";

export default class InformationSectionRecurrent extends Component {
  constructor(props) {
    super(props);
    const { model } = this.props;
    this.state = {
      confirmationRequired: model.subsidy
        ? model.subsidy.confirmationRequired
        : true,
    };
  }

  handleCancel = () => {
    window.location.href = "/benefits";
    resetAllowanceMemory();
  };

  handleSubmit = () => {
    const { model } = this.props;
    const { confirmationRequired } = this.state;
    saveRecurrentSubsidy({
      model,
      confirmationRequired,
    });
  };

  render() {
    const { totalAmount } = this.props;
    const { confirmationRequired } = this.state;
    return (
      <div className="information-section recurrent">
        <p className="title-section">
          {t("subsidy-section.info-subsidy-payroll-close")}{" "}
          {new Intl.NumberFormat("es-ES", {
            style: "currency",
            currency: "EUR",
          }).format(totalAmount)}
        </p>

        <div className="cob-btn-group top-group">
          <div
            className="cob-checkbox"
            onClick={() => {
              this.setState({
                confirmationRequired: !confirmationRequired,
              });
            }}
            role="presentation"
          >
            {confirmationRequired && <FontAwesomeIcon icon="check" />}
          </div>
          <p className="check-description">
            {t("subsidy-section.recurrent-subsidy-info-1")}{" "}
            <b>{t("subsidy-section.recurrent-subsidy-info-2")}</b>{" "}
            {t("subsidy-section.recurrent-subsidy-info-3")}
          </p>
        </div>

        <div className="cob-btn-group right-group">
          <button type="button" className="cob-btn" onClick={this.handleCancel}>
            {t("actions.cancel")}
          </button>
          <button
            type="button"
            className="cob-btn btn-primary"
            disabled={totalAmount <= 0}
            onClick={this.handleSubmit}
          >
            {t("subsidy-section.recurrent-subsidy-action")}
          </button>
        </div>
      </div>
    );
  }
}

InformationSectionRecurrent.defaultProps = {};
InformationSectionRecurrent.propTypes = {
  model: PropTypes.object.isRequired,
  totalAmount: PropTypes.number.isRequired,
};
